<template>
  <div
    class="home"
    id="home"
    :style="{'transformOrigin':'center top','transform':`scale(${scalseNum},${scalseNum})`}"
  >
    <div class="header">
      <div class="nav-box left">
        <div class="nav active">入户安检情况</div>
        <div class="nav">管线巡检系统</div>
        <div class="nav">安全隐患系统</div>
        <div class="nav">实时监控系统</div>
      </div>
      <div class="nav-box center">
        <div class="title">
          <img src="../assets/header_bg_title.png" style="width: auto;max-width: 100%;"/>
        </div>
      </div>
      <div class="nav-box right">
        <div class="nav">实时报警系统</div>
        <div class="nav">客户服务系统</div>
        <div class="nav">客户黑名单</div>
        <div class="nav">非居民流量</div>
      </div>
    </div>
    <div class="content">
      <div class="left">
        <div class="box">
          <div class="title">入户安检情况</div>
          <div class="title-box">
            <div class="item">
              <div class="name a">600</div>
              <div class="desc">安检总量（户）</div>
            </div>
            <div class="item">
              <div class="name b">300</div>
              <div class="desc">已完成量（户）</div>
            </div>
            <div class="item">
              <div class="name c">300</div>
              <div class="desc">未完成量（户）</div>
            </div>
            <div class="item">
              <div class="name d">50</div>
              <div class="desc" style="width:90px;">
                <span style="white-space:nowrap">安检完成率（%）</span>
              </div>
            </div>
          </div>
          <div id="rhaj"></div>
        </div>
        <div class="box">
          <div class="title">管线巡检信息</div>
          <div id="gxxc"></div>
        </div>
        <div class="box">
          <div class="title">安全隐患信息</div>
          <div class="title-box" style="color:#FF0000;height: 25px;">
            <marquee>
              <p style="color:#eff107">{{anyhDataDisplay}}</p>
            </marquee>
            <!-- <h4 style="color:#FF0000">{{message}}</h4> -->
          </div>
          <div id="aqyh"></div>
        </div>
      </div>
      <div class="center">
        <!-- <div class="center-bg">
          <div class="bg"></div>
        </div>-->
        <div class="city-box">
          <vChina class="city"></vChina>
        </div>
        <div class="center-box">
          <div class="table-box left">
            <div class="title">流量在线监控</div>
            <div class="btn-box">
              <div class="btn active">监控列表</div>
              <div class="btn">全部项目</div>
            </div>
            <div class="table">
              <table cellpadding="0" cellspacing="0">
                <thead>
                  <tr>
                    <td>公司名</td>
                    <td>设备数</td>
                    <td>传感器数</td>
                    <td>操作</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(war,index) in comList" :key="index">
                    <td>{{war.name}}</td>
                    <td>{{war.nodeNum}}</td>
                    <td>{{war.nodeNum * 5}}</td>
                    <td>
                      <span style="cursor:pointer" class="rad-btn" @click="handleclick(war.id)">报警记录</span>
                      <span
                        style="cursor:pointer"
                        class="blue-btn"
                        @click="handleclick2(war.id)"
                      >历史数据</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--报警记录列表-->
          <el-dialog
            title="报警记录"
            :visible.sync="openOff"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
          >
            <div class>
              <table cellpadding="0" cellspacing="0" width="100%">
                <thead>
                  <tr align="center">
                    <td width="16%">序号</td>
                    <td width="16%">报警名称</td>
                    <td width="16%">报警级别</td>
                    <td width="16%">实际值</td>
                    <td width="16%">处理标志</td>
                    <td width="16%">时间</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(war,index) in comWarList" :key="index" align="center">
                    <td width="16%">{{index+1}}</td>
                    <td width="16%">{{war.iName}}</td>
                    <td
                      width="16%"
                      class="red"
                    >{{war.iot_trigger_alarm_level==39?'严重':war.iot_trigger_alarm_level==40?'紧急':war.iot_trigger_alarm_level==41?'一般':war.iot_trigger_alarm_level}}</td>
                    <td width="16%">{{war.sdata}}</td>
                    <td width="16%" class="yel">{{war.iot_alarm_process_status==46?'未处理':'已处理'}}</td>
                    <td width="16%">{{war.ctime}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-dialog>
          <!--历史数据列表-->
          <el-dialog
            title="历史数据"
            :visible.sync="openOff2"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
          >
            <div class>
              <table cellpadding="0" cellspacing="0" width="100%">
                <thead>
                  <tr align="center">
                    <td width="10%">序号</td>
                    <td width="30%">设备名称</td>
                    <td width="15%">传感器</td>
                    <td width="15%">类型</td>
                    <td width="15%">数值</td>
                    <td width="15%">时间</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(war,index) in comLocList" :key="index" align="center">
                    <td width="10%">{{index+1}}</td>
                    <td width="30%">{{war.nodeName}}</td>
                    <td width="15%">{{war.sensor_name}}</td>
                    <td
                      width="15%"
                    >{{war.iot_sensor_type==25?'连续型':war.iot_sensor_type==26?'离散型':war.iot_sensor_type==27?'开关型':war.iot_sensor_type}}</td>
                    <td width="15%">{{war.sdata}}</td>
                    <td width="15%">{{war.atimestr}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-dialog>
          <div class="table-box right">
            <div class="title">最新预警信息</div>
            <div class="btn-box"></div>
            <div class="table">
              <table cellpadding="0" cellspacing="0">
                <thead>
                  <tr>
                    <td>序号</td>
                    <td>报警名称</td>
                    <td>报警级别</td>
                    <td>实际值</td>
                    <td>处理标志</td>
                    <td>时间</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(war,index) in warningList" :key="index">
                    <td>{{index+1}}</td>
                    <td>{{war.name}}</td>
                    <td
                      class="red"
                    >{{war.iot_trigger_alarm_level==39?'严重':war.iot_trigger_alarm_level==40?'紧急':war.iot_trigger_alarm_level==40?'一般':war.iot_trigger_alarm_level}}</td>
                    <td>{{war.sdata}}</td>
                    <td class="yel">{{war.iot_alarm_process_status==46?'未处理':'已处理'}}</td>
                    <td>{{war.atimestr}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="box">
          <div class="title">非居民用户计量信息</div>
          <div class="title-box" style="color:#FF0000;height: 25px;">
            <marquee>
              <p style="color:#eff107">数据滚动显示 数据滚动显示 数据滚动显示 数据滚动显示 数据滚动显示</p>
            </marquee>
            <!-- <h4 style="color:#FF0000">{{message}}</h4> -->
          </div>

          <div id="fjm"></div>

          <!-- <div style="width:100%;text-align:center">
            <img :src="fjmsrc" width="60%" />
          </div>-->
        </div>
        <div class="box">
          <div class="title">客户服务信息</div>
          <div class="table">
            <table cellpadding="0" cellspacing="0" border="1px solid #1467b7">
              <thead>
                <tr>
                  <td rowspan="2">2019/10/14</td>
                  <td colspan="2">传感器数</td>
                  <td colspan="2">报警数</td>
                  <td colspan="2">操作</td>
                </tr>
                <tr>
                  <td>质量</td>
                  <td>服务</td>
                  <td>质量</td>
                  <td>服务</td>
                  <td>质量</td>
                  <td>服务</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>已处理</td>
                  <td>12</td>
                  <td>233</td>
                  <td>1234</td>
                  <td>222</td>
                  <td>222</td>
                  <td>222</td>
                </tr>
                <tr>
                  <td>处理中</td>
                  <td>12</td>
                  <td>233</td>
                  <td>1234</td>
                  <td>222</td>
                  <td>222</td>
                  <td>222</td>
                </tr>
                <tr>
                  <td>未处理</td>
                  <td>12</td>
                  <td>233</td>
                  <td>1234</td>
                  <td>222</td>
                  <td>222</td>
                  <td>222</td>
                </tr>
                <tr>
                  <td>合计</td>
                  <td>12</td>
                  <td>233</td>
                  <td>1234</td>
                  <td>222</td>
                  <td>222</td>
                  <td>222</td>
                </tr>
                <tr class="zj">
                  <td>总计</td>
                  <td colspan="2">12</td>
                  <td colspan="2">233</td>
                  <td colspan="2">111</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="box">
          <div class="title">客户黑名单管理</div>

          <div class="title-box">
            <div class="item">
              <div class="name a">120</div>
              <div class="desc">黑名单总量</div>
            </div>
            <div class="item">
              <div class="name b">20</div>
              <div class="desc">已处理</div>
            </div>
            <div class="item" style="width:26%">
              <div class="name c">100</div>
              <div class="desc">费用占用（万元）</div>
            </div>
            <div class="item" style="width:26%">
              <div class="name d">33.15</div>
              <div class="desc">处理完成率（%）</div>
            </div>
          </div>

          <div class="hmd">
            <div id="hmd" class="item"></div>
            <div id="hmd1" class="item"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="open" @click="scalsePage()"></div> -->
    <!-- <div class="open" @click="toggleFullScreen($event)"></div> -->
  </div>
</template>

<script>
import echarts from "echarts";
// import 'echarts/map/js/world.js'
// import 'echarts/map/js/china.js'
// import 'echarts-gl'
import vdq from "./common/word3d.vue";
import vChina from "./common/city.vue";
import axios from "axios";
import qs from "qs";
import BMap from "BMap";
// import JSON from 'echarts/map/json/province/shanxi1.json';
import { getPointTotal, getPointComplete, getDangerList } from "@/api/api";
import moment from "moment";
import _ from "lodash";
var comNameListTop = [
  "扶风分公司",
  "太白分公司",
  "白水分公司",
  "澄城分公司",
  "阎良分公司",
  "秦汉分公司"
];
var comAlarmCountTop = [0, 0, 0, 0, 0, 0];
var war = [];
var list2 = [];
var comWar = [];
var comLoc = [];
var fjmItemStyles = [
  {
    color: {
      colorStops: [
        {
          offset: 0,
          color: "#ee8f12" // 0% 处的颜色
        },
        {
          offset: 1,
          color: "#e38716" // 100% 处的颜色
        }
      ]
    }
  },
  {
    color: {
      colorStops: [
        {
          offset: 0,
          color: "#e38716" // 0% 处的颜色
        },
        {
          offset: 1,
          color: "#c77320" // 100% 处的颜色
        }
      ]
    }
  },
  {
    color: {
      colorStops: [
        {
          offset: 0,
          color: "#c77320" // 0% 处的颜色
        },
        {
          offset: 1,
          color: "#9c562f" // 100% 处的颜色
        }
      ]
    }
  },
  {
    color: {
      colorStops: [
        {
          offset: 0,
          color: "#9c562f" // 0% 处的颜色
        },
        {
          offset: 1,
          color: "#532349" // 100% 处的颜色
        }
      ]
    }
  },
  {
    color: {
      colorStops: [
        {
          offset: 0,
          color: "#044511" // 0% 处的颜色
        },
        {
          offset: 1,
          color: "#0b5f1b" // 100% 处的颜色
        }
      ]
    }
  },
  {
    color: {
      colorStops: [
        {
          offset: 0,
          color: "#0b5f1b" // 0% 处的颜色
        },
        {
          offset: 1,
          color: "#147d27" // 100% 处的颜色
        }
      ]
    }
  },
  {
    color: {
      colorStops: [
        {
          offset: 0,
          color: "#147d27" // 0% 处的颜色
        },
        {
          offset: 1,
          color: "#20a837" // 100% 处的颜色
        }
      ]
    }
  },
  {
    color: {
      colorStops: [
        {
          offset: 0,
          color: "#000cff" // 0% 处的颜色
        },
        {
          offset: 1,
          color: "#0026ff" // 100% 处的颜色
        }
      ]
    }
  },
  {
    color: {
      colorStops: [
        {
          offset: 0,
          color: "#0026ff" // 0% 处的颜色
        },
        {
          offset: 1,
          color: "#0079ff" // 100% 处的颜色
        }
      ]
    }
  },
  {
    color: {
      colorStops: [
        {
          offset: 0,
          color: "#0079ff" // 0% 处的颜色
        },
        {
          offset: 1,
          color: "#00a5ff" // 100% 处的颜色
        }
      ]
    }
  }
];
export default {
  name: "home",
  props: {},
  components: {
    vdq,
    vChina
  },
  data() {
    getWarningList();
    getComList();
    //initxdbj();
    return {
      fjmsrc: require("../assets/fjm.png"),
      kuang_07: require("../assets/kuang_07.png"),
      message: "暂无最新数据!",
      timer: null, //在data上定义定时器timer，默认为null
      openOff: false,
      openOff2: false,
      warningList: war,
      comList: list2,
      comWarList: comWar,
      comLocList: comLoc,
      isFullscreen: true,
      showMap: 1,
      scalseNum: 1,
      nowDate: "",
      nowTime: "",
      nowWeek: "",
      echartsObj: "",
      chinaMapObj: "",
      tableLength: ["1", "2", "3", "4"],
      tableLength1: ["1", "2", "3", "4", "5"],
      anyhDataDisplay: "",
      rhajOption: {
        //comNameListTop:["扶风分公司","太白分公司","白水分公司","澄城分公司","阎良分公司","秦汉分公司","延长分公司","延川分公司","宜川分公司","志丹分公司","吴起分公司"],
        color: ["#00ff00", "#ffff00"],
        legend: {
          show: true,
          top: "15px",
          right: "15px",
          textStyle: {
            color: "#9ad3ed",
            fontSize: 10
          }
        },
        tooltip: {
          trigger: "axis",
          showContent: false
        },
        xAxis: {
          type: "category",
          splitNumber: "12",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ],
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#9ad3ed"
            }
          },
          axisLabel: {
            show: true,
            interval: 0
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#9ad3ed"
            }
          },
          splitLine: {
            lineStyle: {
              color: "#9ad3ed"
            }
          }
        },
        series: [
          {
            name: "安检总量",
            type: "line",
            smooth: true,
            seriesLayoutBy: "row",
            data: [
              530,
              920,
              320,
              1000,
              900,
              500,
              390,
              990,
              370,
              660,
              820,
              790,
              200,
              500,
              400
            ],
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00ff00"
                  },
                  {
                    offset: 1,
                    color: "#06105a"
                  }
                ])
              }
            }
          },
          {
            name: "已完成量",
            type: "line",
            smooth: true,
            seriesLayoutBy: "row",
            data: [130, 700, 200, 800, 500, 200, 90, 880, 100, 500, 700, 200],
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#ffff00"
                  },
                  {
                    offset: 1,
                    color: "#06105a"
                  }
                ])
              }
            }
          }
        ],
        grid: {
          backgroundColor: "rgba(255,255,255,0)",
          borderColor: "#068fc2",
          shadowColor: "rgba(0, 0, 0, 0.5)",
          left: "15%",
          bottom: "18%"
        }
      },
      gxxcOption: {
        color: ["#ff00ff"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        legend: {
          show: true,
          top: "10px",
          right: "15px",
          textStyle: {
            color: "#9ad3ed",
            fontSize: 10
          },
          data: ["计划完成数", "实际完成数"]
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月"
            ],
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              show: true,
              interval: 0,
              lineStyle: {
                color: "#9ad3ed"
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#9ad3ed"
              }
            },
            axisTick: {
              show: false,
              alignWithLabel: true
            }
          },
          {
            type: "category",
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "12月"
            ],
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              show: false,
              interval: 0,
              lineStyle: {
                color: "#9ad3ed"
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#9ad3ed"
              }
            },
            axisTick: {
              show: false,
              alignWithLabel: true
            }
          }
        ],
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#9ad3ed"
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#9ad3ed"
            }
          }
        },
        series: [
          {
            name: "计划完成数",
            type: "bar",
            data: [40, 20, 60, 15, 25, 35, 15, 25, 35, 15, 25, 35],
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#e98b13"
                  },
                  { offset: 0.8, color: "#73393e" },
                  {
                    offset: 1,
                    color: "#3b1252"
                  }
                ])
              }
            }
          },
          {
            name: "实际完成数",
            type: "line",
            data: [14, 80, 25, 13, 70, 20, 13, 20, 20],
            symbolSize: 8,
            xAxisIndex: 1,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#ff00ff"
                  },
                  { offset: 0.5, color: "#ff00ff" },
                  {
                    offset: 1,
                    color: "#ff00ff"
                  }
                ])
              }
            }
          }
        ],
        label: {
          show: true,
          color: "#fff"
        },
        grid: {
          backgroundColor: "rgba(255,255,255,0)",
          borderColor: "#068fc2",
          shadowColor: "rgba(0, 0, 0, 0.5)",
          left: "13%",
          bottom: "15%"
        }
      },
      aqyhOption: {
        color: ["#ff00ff"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        legend: {
          show: true,
          top: "10px",
          right: "15px",
          textStyle: {
            color: "#9ad3ed",
            fontSize: 10
          },
          data: ["已处理隐患量", "已发现隐患量"]
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月"
            ],
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              show: true,
              interval: 0,
              lineStyle: {
                color: "#9ad3ed"
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#9ad3ed"
              }
            },
            axisTick: {
              show: false,
              alignWithLabel: true
            }
          }
        ],
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#9ad3ed"
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#9ad3ed"
            }
          }
        },
        series: [
          {
            type: "bar",
            name: "已处理隐患量",
            data: [200, 500, 400, 200, 500, 400, 200, 500, 400],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#2d78f3"
                  },
                  { offset: 0.5, color: "#26b6fa" },
                  {
                    offset: 1,
                    color: "#21e6ff"
                  }
                ])
              }
            },
            markLine: {
              silent: true,
              lineStyle: { normal: { type: "dashed" } },
              label: { show: true, position: "end" },
              symbol: [null, "arrow"],
              symbolSize: 7,
              data: [
                {
                  yAxis: 213.62,
                  lineStyle: { width: 1.6560000000000001, color: "#21e6ff" }
                }
              ]
            }
          },
          {
            name: "已发现隐患量",
            type: "bar",
            data: [100, 800, 700],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#fff795"
                  },
                  { offset: 0.5, color: "#fff33f" },
                  {
                    offset: 1,
                    color: "#fff103"
                  }
                ])
              }
            },
            markLine: {
              silent: true,
              lineStyle: { normal: { type: "dashed" } },
              label: { show: true, position: "end" },
              symbol: [null, "arrow"],
              symbolSize: 7,
              data: [
                {
                  yAxis: 210.62,
                  lineStyle: { width: 1.6560000000000001, color: "#fff103" }
                }
              ]
            }
          }
        ],
        grid: {
          backgroundColor: "rgba(255,255,255,0)",
          borderColor: "#068fc2",
          shadowColor: "rgba(0, 0, 0, 0.5)",
          left: "13%",
          bottom: "20%"
        },
        markLine: {
          symbol: "none",
          silent: true,
          lineStyle: { normal: { type: "dashed" } },
          label: { position: "start" },
          data: [
            {
              yAxis: 500,
              lineStyle: { width: 1.6560000000000001, color: "#ff6367" },
              label: { show: false }
            },
            {
              yAxis: 200,
              lineStyle: { width: 1.6560000000000001, color: "#D8D8D8" },
              label: { show: false }
            }
          ]
        }
      },
      fjmOption: {
        title: {
          text: "非居民",
          left: "center",
          top: "30%",
          textStyle: {
            color: "#fff",
            fontSize: 12
          }
        },
        backgroundColor: "",
        color: [
          "#2ec7c9",
          "#b6a2de",
          "#5ab1ef",
          "#ffb980",
          "#d87a80",
          "#8d98b3",
          "#FFEA01",
          "#B8D07C",
          "#fca4bb",
          "#dc69aa",
          "#07a2a4",
          "#9a7fd1",
          "#588dd5",
          "#f5994e",
          "#c05050",
          "#59678c",
          "#c9ab00",
          "#7eb00a",
          "#6f5553",
          "#c14089"
        ],
        tooltip: {
          backgroundColor: "rgba(255,255,255,0)",
          trigger: "item",
          padding: 0,
          formatter: params => {
            let temHtml = `<div>
            <img src="${this.kuang_07}"  width="130"/>
            <div style="position:absolute;top:10px;left:20px;color:#fff;line-height:2">
            <p>用户数量：<span style="color:#ff00ff">${params.value ||
              1290}</span></p>
            <p>使用量：<span style="color:#00ff00">${params.value2 ||
              920}</span></p></p>
            </div>
            </div>`;
            return temHtml;
          }
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["15%", "35%"],
            center: ["50%", "35%"],
            label: {
              normal: {
                position: "inner"
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            itemStyle: {
              borderWidth: 1,
              borderColor: "#050f57"
            },
            hoverAnimation: false,
            data: [
              {
                name: "其它工厂",
                value: 10,
                itemStyle: {
                  color: {
                    type: "radial",
                    r: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#00e2ff" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#0020ff" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                }
              },
              {
                name: "制造厂",
                value: 10,
                itemStyle: {
                  color: {
                    colorStops: [
                      {
                        offset: 0,
                        color: "#21a937" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#054812" // 100% 处的颜色
                      }
                    ]
                  }
                }
              },
              {
                name: "工业能源",
                value: 10,
                itemStyle: {
                  color: {
                    type: "radial",
                    r: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#e78a14" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#5b2846" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                }
              }
            ]
          },
          {
            name: "访问来源",
            type: "pie",
            radius: ["45%", "65%"],
            center: ["50%", "35%"],
            data: [
              {
                name: "扶风分公司",
                value: 10
              },
              {
                name: "太白分公司",
                value: 10
              },
              {
                name: "白水分公司",
                value: 10
              },
              {
                name: "澄城分公司",
                value: 10
              },
              {
                name: "阎良分公司",
                value: 10
              },
              {
                name: "秦汉分公司",
                value: 10
              },
              {
                name: "延川分公司",
                value: 10
              },
              {
                name: "蓝田分公司",
                value: 10
              },
              {
                name: "宜川分公司",
                value: 10
              }
            ].map((item, index) => {
              item.itemStyle = fjmItemStyles[index];
              return item;
            }),
            labelLine: {
              normal: {
                length: 5,
                length2: 5
              }
            },
            itemStyle: {
              borderWidth: 1,
              borderColor: "#050f57"
            },
            label: {
              normal: {
                textStyle: {
                  color: "#ffffff"
                }
              }
            },
            hoverAnimation: false
          }
        ]
      },
      hmdOption: {
        backgroundColor: "rgba(255, 255, 255, 0)",
        legend: {
          orient: "vertical",
          type: "scroll",
          left: 0,
          textStyle: {
            color: "#fff",
            fontSize: 8
          },
          icon:
            "path://M1024.101307 260.449847 800.725844 799.642163c-94.910627-35.338856-197.408045-53.000098-307.451324-53.000098-94.938256 0-184.037527 13.135158-267.326465 39.356356L1.023306 246.828618c152.463414-54.536081 316.556703-81.777515 492.251214-81.777515C683.09782 165.051103 860.052021 196.84318 1024.101307 260.449847z"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "55%",
            center: ["62%", "50%"],
            clockwise: false,
            data: [
              {
                value: 45,
                name: "销售1"
              },
              {
                value: 25,
                name: "销售2"
              },
              {
                value: 15,
                name: "销售3"
              },
              {
                value: 8,
                name: "销售4"
              },
              {
                value: 7,
                name: "销售5"
              }
            ],
            itemStyle: {
              normal: {
                borderWidth: 0,
                borderColor: "#ffffff"
              },
              emphasis: {
                borderWidth: 0,
                shadowBlur: 0,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            },
            labelLine: {
              length: 10,
              length2: 0,
              lineStyle: {
                type: "solid"
              }
            }
          }
        ],
        color: ["#00b7ee", "#32b16c", "#0068b7", "#cfa972", "#004986"]
      }
    };
  },
  mounted() {
    //计算缩放比例
    // this.resize_window();
    // window.addEventListener('resize', () => {
    //     this.resize_window();
    // });
    let _that = this;
    window.onresize = function() {
      if (!_that.checkFull()) {
        //要执行的动作
        _that.isFullscreen = true;
      }
    };
    this.show();
    let rhaj = echarts.init(document.getElementById("rhaj"));
    rhaj.setOption(this.rhajOption);

    // 巡检信息
    let gxxc = echarts.init(document.getElementById("gxxc"));
    axios.all([getPointTotal(), getPointComplete()]).then(
      axios.spread((totals, completes) => {
        const data1 = [];
        const data2 = [];
        totals.data.forEach(element => {
          data1.push(element["P"]);
        });

        completes.data.forEach(element => {
          data2.push(element["P"]);
        });
        this.gxxcOption.series[0].data = data1;
        this.gxxcOption.series[1].data = data2;

        gxxc.setOption(this.gxxcOption);
      })
    );

    let aqyh = echarts.init(document.getElementById("aqyh"));
    axios.all([getDangerList(-1), getDangerList(1)]).then(
      axios.spread((totals, completes) => {
        let discoverRes = totals.data.Data.Rows,
          handledRes = completes.data.Data.Rows;
        const anyhDataDisplayArray = [];
        let count = 1;
        for (let res of discoverRes) {
          anyhDataDisplayArray.push(
            `${res.danger_address}:${res.danger_state_des}`
          );
          count += 1;
          if (count > 10) break;
        }

        this.anyhDataDisplay = anyhDataDisplayArray.join(" ");
        // console.log(discoverRes, handledRes);
        //筛选已处理
        // handledResData = [];
        const handledResDataKeys = [];
        //筛选全部
        // const discoverResData = [];
        const discoverResDataKeys = [];
        discoverRes.forEach(item => {
          discoverResDataKeys.push(moment(item.createtime).format("MM"));

          if (item.danger_state_des == "已处理") {
            handledResDataKeys.push(
              moment(item.danger_handle_date).format("MM")
            );
          }
        });
        //分组数据
        const discoverData = _.groupBy(discoverResDataKeys.sort());
        const handledData = _.groupBy(handledResDataKeys.sort());
        let discoverDispalyData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        let handledDispalyData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (let key in discoverData) {
          discoverDispalyData[parseInt(key) - 1] = discoverData[key].length;
        }
        for (let key in handledData) {
          handledDispalyData[parseInt(key) - 1] = handledData[key].length;
        }

        let _median = arr => {
          //求中位数
          if (arr.length % 2 == 0) {
            return (arr[arr.length / 2 - 1] + arr[arr.length / 2]) / 2;
          } else {
            return arr[Math.floor(arr.length / 2)];
          }
        };

        this.aqyhOption.series[0].data = discoverDispalyData;

        this.aqyhOption.series[0].markLine.data[0].yAxis = _median(
          discoverDispalyData
            .filter(item => {
              return item > 0;
            })
            .sort((a, b) => b - a)
            .reverse()
        );

        this.aqyhOption.series[1].data = handledDispalyData;
        this.aqyhOption.series[1].markLine.data[0].yAxis = _median(
          handledDispalyData
            .filter(item => {
              return item > 0;
            })
            .sort((a, b) => b - a)
            .reverse()
        );
        aqyh.setOption(this.aqyhOption);
      })
    );

    let fjm = echarts.init(document.getElementById("fjm"));
    fjm.setOption(this.fjmOption);
    let hmd = echarts.init(document.getElementById("hmd"));
    hmd.setOption(this.hmdOption);
    let hmd2 = echarts.init(document.getElementById("hmd1"));
    hmd2.setOption(this.hmdOption);
    /*let hmd1 = echarts.init(document.getElementById('hmd1'));
    hmd1.setOption(this.hmdOption1);*/
    /*setInterval(()=>{
      // Math.ceil(Math.random()*100);  
      rhaj.setOption({
        color: ['#00ff00','#ffff00'],
        legend: {
          show: true,
          top: '25px',
          right: '15px',
          textStyle: {
            color: '#9ad3ed',
            fontSize: 10
          }
        },
        tooltip: {
          trigger: 'axis',
          showContent: false
        },
        xAxis: {
          type: 'category',
          splitNumber: '12',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月','8月','9月','10月','11月','12月'],
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#9ad3ed'
            }
          },
          axisLabel: {
            show: true,
            interval: 0
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#9ad3ed'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#9ad3ed'
            }
          },
        },
        series: [
          {
            name:'安检总量',
            type: 'line', smooth: true, seriesLayoutBy: 'row',
            data: [Math.ceil(Math.random()*100), Math.ceil(Math.random()*100), Math.ceil(Math.random()*100)],
            areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#00ff00'
                  }, {
                      offset: 1,
                      color: '#06105a'
                  }])
                }
            },
          },
          {
            name:'已完成量',
            type: 'line', smooth: true, seriesLayoutBy: 'row',
            data: [Math.ceil(Math.random()*100), Math.ceil(Math.random()*100), Math.ceil(Math.random()*100)],
            areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#ffff00'
                  }, {
                      offset: 1,
                      color: '#06105a'
                  }])
                }
            },
          }
        ],
        grid: {
          backgroundColor: 'rgba(255,255,255,0)',
          borderColor: '#068fc2',
          shadowColor: 'rgba(0, 0, 0, 0.5)',
          left: '15%',
          bottom: '18%'
        }
      });
      gxxc.setOption({
        color: ['#ff00ff'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          show: true,
          top: '25px',
          right: '15px',
          textStyle: {
            color: '#9ad3ed',
            fontSize: 10
          },
          data:['计划完成数','实际完成数']
        },
        xAxis: [
          {
            type: 'category',
            data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              show: true,
              interval: 0,
              lineStyle: {
                color: '#9ad3ed'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#9ad3ed'
              }
            },
            axisTick: {
              show: false,
              alignWithLabel: true
            },
          },
        ],
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#9ad3ed'
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#9ad3ed'
            }
          },
        },
        series: [
          {
            name:'计划完成数',
            type:'bar',
            data:[Math.ceil(Math.random()*100), Math.ceil(Math.random()*100), Math.ceil(Math.random()*100)],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#6AFF04'
                }, {offset: 0.5, color: '#6AFF04'},{
                    offset: 1,
                    color: '#3a1152'
                }])
              }
            },
          },
          {
            name:'实际完成数',
            type:'line',
            data:[Math.ceil(Math.random()*100), Math.ceil(Math.random()*100), Math.ceil(Math.random()*100)],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#60FFFF'
                }, {offset: 0.5, color: '#60FFFF'},{
                    offset: 1,
                    color: '#3a1152'
                }])
              }
            }
          }
        ],
        grid: {
          backgroundColor: 'rgba(255,255,255,0)',
          borderColor: '#068fc2',
          shadowColor: 'rgba(0, 0, 0, 0.5)',
          left: '13%',
          bottom: '15%'
        }
      });
    },1600)*/
    setInterval(() => {
      let len = Math.ceil(Math.random() * 10);
      let list = [];
      for (let i = 0; i < len; i++) {
        list.push(String(i));
      }
      this.tableLength = list;
    }, 1200);
    setInterval(() => {
      // rhaj.setOption(this.rhajOption);
      let len = Math.ceil(Math.random() * 10);
      let list = [];
      for (let i = 0; i < len; i++) {
        list.push(String(i));
      }
      this.tableLength1 = list;
    }, 2200);
    /*setInterval(()=>{
      hmd.setOption({
        color: ['#ff00ff'],
        xAxis: [
          {
            type: 'category',
            data: ['太白','扶风','吴起','宜川','志丹','白水','澄城','阎良','蓝田','秦汉'],
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              show: true,
              interval: 0,
              lineStyle: {
                color: '#9ad3ed'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#9ad3ed'
              }
            },
            axisTick: {
              show: false,
              alignWithLabel: true
            },
          },
        ],
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#9ad3ed'
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#9ad3ed'
            }
          },
        },
        series: [
          {
            name:'计划完成数',
            type:'bar',
            data:[Math.ceil(Math.random()*100), Math.ceil(Math.random()*100), Math.ceil(Math.random()*100),
             Math.ceil(Math.random()*100), Math.ceil(Math.random()*100), Math.ceil(Math.random()*100), Math.ceil(Math.random()*100)
             , Math.ceil(Math.random()*100), Math.ceil(Math.random()*100), Math.ceil(Math.random()*100)],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#C3FF9B'
                }, {offset: 0.5, color: '#C3FF9B'},{
                    offset: 1,
                    color: '#3a1152'
                }])
              }
            },
          },
        ],
        grid: {
          backgroundColor: 'rgba(255,255,255,0)',
          borderColor: '#068fc2',
          shadowColor: 'rgba(0, 0, 0, 0.5)',
        }
      });
      aqyh.setOption({
        color: ['#ff00ff'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          show: true,
          top: '30px',
          right: '15px',
          textStyle: {
            color: '#9ad3ed',
            fontSize: 10
          },
          data:['已处理隐患量','已发现隐患量']
        },
        xAxis: [
          {
            type: 'category',
            data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              show: true,
              interval: 0,
              lineStyle: {
                color: '#9ad3ed'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#9ad3ed'
              }
            },
            axisTick: {
              show: false,
              alignWithLabel: true
            },
          },
        ],
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#9ad3ed'
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#9ad3ed'
            }
          },
        },
        series: [
          {type: 'bar',
            name:'已处理隐患量',
            data:[Math.ceil(Math.random()*100), Math.ceil(Math.random()*100), Math.ceil(Math.random()*100)],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#2d78f3'
                }, {offset: 0.5, color: '#26b6fa'},{
                    offset: 1,
                    color: '#21e6ff'
                }])
              }
            },
          },
          {
            name:'已发现隐患量',
            type:'bar',
            data:[Math.ceil(Math.random()*100), Math.ceil(Math.random()*100), Math.ceil(Math.random()*100)],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#fff795'
                }, {offset: 0.5, color: '#fff33f'},{
                    offset: 1,
                    color: '#fff103'
                }])
              }
            },
          }
        ],
        grid: {
          backgroundColor: 'rgba(255,255,255,0)',
          borderColor: '#068fc2',
          shadowColor: 'rgba(0, 0, 0, 0.5)',
          left: '13%',
          bottom: '20%'
        }
      });
    },1900)*/
    // this.initMap()
  },
  methods: {
    handleclick(id) {
      var data = { id: id };
      var that = this;
      axios
        .post(
          "http://117.34.91.41.250:8083/sirenController/getComWarList",
          //axios.post("http://localhost:8083/sirenController/getComWarList",
          qs.stringify(data)
        )
        .then(res => {
          comWar.length = 0;
          for (var i = 0; i < res.data.length; i++) {
            comWar.push(res.data[i]);
          }
          that.openOff = true; //默认页面不显示为false,点击按钮将这个属性变成true
        });
    },
    handleclick2(id) {
      var data = { id: id };
      var that = this;
      axios
        .post(
          "http://117.34.91.41:8083/sirenController/getComLocList",
          //axios.post("http://localhost:8083/sirenController/getComLocList",
          qs.stringify(data)
        )
        .then(res => {
          comLoc.length = 0;
          for (var i = 0; i < res.data.length; i++) {
            comLoc.push(res.data[i]);
          }
          that.openOff2 = true; //默认页面不显示为false,点击按钮将这个属性变成true
        });
    },
    show() {
      if (this.timer != null) return;
      this.timer = setInterval(() => {
        //获取到头的第一个字符
        let start = this.message.substring(0, 1);
        //获取到后面的所有字符
        let end = this.message.substring(1);
        //重新拼接得到新的字符串，并赋值给this.message
        this.message = end + start;
      }, 1000);
    },
    chinaMap() {
      this.showMap = 2;
      this.myChart = {};
      this.chinaMapObj = echarts.init(document.getElementById("china"));
      this.chinaMapObj.setOption({
        backgroundColor: "rgba(0,0,0,0)", //canvas的背景颜色
        // environment: './bg.png',//背景星空图
        geo3D: {
          //地图的具体参数
          map: "china", //地图范围
          shading: "lambert", //光照带来的明暗
          light: {
            // 光照相关的设置。在 shading 为 'color' 的时候无效。
            main: {
              //场景主光源的设置
              intensity: 5, //主光源的强度
              shadow: true, //主光源是否投射阴影
              shadowQuality: "high", //阴影的质量
              alpha: 30, //主光源绕 x 轴偏离的角度
              beta: 190 //主光源绕 y 轴偏离的角度
            },
            ambient: {
              //全局的环境光设置。
              intensity: 0 //环境光的强度
            }
          },
          viewControl: {
            //用于鼠标的旋转，缩放等视角控制
            distance: 50, //默认视角距离主体的距离
            panMouseButton: "left", //平移操作使用的鼠标按键
            rotateMouseButton: "right", //旋转操作使用的鼠标按键
            alpha: 50 // 让canvas在x轴有一定的倾斜角度
          },
          postEffect: {
            //为画面添加高光，景深，环境光遮蔽（SSAO），调色等效果
            enable: true, //是否开启
            SSAO: {
              //环境光遮蔽
              radius: 1, //环境光遮蔽的采样半径。半径越大效果越自然
              intensity: 1, //环境光遮蔽的强度
              enable: true
            }
          },
          temporalSuperSampling: {
            //分帧超采样。在开启 postEffect 后，WebGL 默认的 MSAA 会无法使用,分帧超采样用来解决锯齿的问题
            enable: true
          },
          itemStyle: {
            //三维图形的视觉属性
            color: "#2355ac",
            borderWidth: 1,
            borderColor: "#000"
          },
          regionHeight: 2 //区域的高度
        }
      });
    },
    hideDqMapFn() {
      this.showMap = 2;
    },
    checkFull() {
      var isFull =
        document.fullscreenEnabled ||
        window.fullScreen ||
        document.webkitIsFullScreen ||
        document.msFullscreenEnabled;
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },
    FullScreen(el) {
      if (this.isFullscreen) {
        //退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (!document.msRequestFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        //进入全屏
        if (el.requestFullscreen) {
          el.requestFullscreen();
        } else if (el.mozRequestFullScreen) {
          el.mozRequestFullScreen();
        } else if (el.webkitRequestFullscreen) {
          el.webkitRequestFullscreen();
        } else if (el.msRequestFullscreen) {
          this.isFullscreen = true;
          el.msRequestFullscreen();
        }
      }
    },
    toggleFullScreen() {
      this.isFullscreen = !this.isFullscreen;
      this.FullScreen(document.getElementById("home"));
    }
  }
};

function initxdbj() {
  var data = {
    postData: "{'key':'sinoto2020','page':1,'rowCount':6,'data':{}}"
  };
  var that = this;
  axios.post("/api/WebMain.asmx/GetAlarmInfo", qs.stringify(data)).then(res => {
    //var alarm = JSON.parse(JSON.stringify(res.data.data));
    /*for (var i = 0; i < alarm.length; i++) {
				alert(alarm[i])
			}*/

    var comNameList = [];
    var comAlarmCount = [];
    for (var i = 0; i < res.data.data.length; i++) {
      comNameList.push(res.data.data[i].AreaName);
      comAlarmCount.push(res.data.data[i].AlarmCount);
    }
    comNameListTop = comNameList;
    comAlarmCountTop = comAlarmCount;
    //alert(comNameList)
  });
}

function getWarningList() {
  //var data = {"postData": "{'key':'sinoto2020','page':1,'rowCount':6,'data':{}}"}
  var that = this;
  axios
    .post(
      "http://117.34.91.41:8083/sirenController/getWarningList"
      //axios.post("http://localhost:8083/sirenController/getWarningList",
      //qs.stringify("")
    )
    .then(res => {
      for (var i = 0; i < res.data.length; i++) {
        war.push(res.data[i]);
      }
    });
}
function getComList() {
  //var data = {"postData": "{'key':'sinoto2020','page':1,'rowCount':6,'data':{}}"}
  var that = this;
  axios
    .post(
      "http://117.34.91.41:8083/sirenController/getComList"
      //axios.post("http://localhost:8083/sirenController/getComList",
      //qs.stringify("")
    )
    .then(res => {
      for (var i = 0; i < res.data.length; i++) {
        list2.push(res.data[i]);
      }
    });
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./home.scss";
.home /deep/ .el-select-dropdown {
  background-color: rgba(255, 255, 255, 0) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue